/**
 * Pre-hydration visibility guard for the step-2 redesign test
 * (`step2_redesign_v1`). Rendered as an inline <script> in the SSG HTML of the
 * step-2 pages (gated on STEP2_REDESIGN_ACTIVE), so it executes during HTML
 * parse — BEFORE React hydrates and before useStep2RedesignVariant can run.
 *
 * If the visitor is (likely) Variant B — `hv=2` in the URL or a sticky
 * `tcc_ab_step2_redesign_v1=B` cookie — it hides the control markup
 * (#s2-control-root) so they never see a flash of the old page while the
 * variant resolves. useStep2RedesignVariant removes the guard the moment the
 * variant is resolved (any arm); the 4s timeout is a fail-safe so a JS error
 * can never leave the page invisible.
 */
export const STEP2_REDESIGN_GUARD_SCRIPT = [
  '(function(){try{',
  "if(!/[?&]hv=2(?:&|$)/.test(window.location.search)&&document.cookie.indexOf('tcc_ab_step2_redesign_v1=B')===-1)return;",
  "document.documentElement.setAttribute('data-s2v','b');",
  "var s=document.createElement('style');s.id='s2v-guard';",
  's.appendChild(document.createTextNode(\'[data-s2v="b"] #s2-control-root{visibility:hidden}\'));',
  '(document.head||document.documentElement).appendChild(s);',
  "window.setTimeout(function(){var e=document.getElementById('s2v-guard');if(e&&e.parentNode)e.parentNode.removeChild(e);document.documentElement.removeAttribute('data-s2v');},4000);",
  '}catch(e){}})();',
].join('');

/**
 * Remove the pre-hydration guard (style + html attribute). Called by
 * useStep2RedesignVariant as soon as the variant is resolved, on every
 * resolution path — for Variant A this un-hides control before first
 * post-hydration paint; for Variant B the hidden control root unmounts anyway.
 * Safe to call when the guard never ran.
 */
export function removeStep2RedesignGuard(): void {
  if (typeof document === 'undefined') return;
  const style = document.getElementById('s2v-guard');
  if (style && style.parentNode) style.parentNode.removeChild(style);
  document.documentElement.removeAttribute('data-s2v');
}
